import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderOpen } from 'lucide-react';
import { Card } from '../ui/Card';
import { WIDGET_HEADER_FLUSH, WidgetCardHeader } from './WidgetCardHeader';
import { Spinner } from '../ui/Spinner';
import { TypeBadge, StageBadge } from '../dossiers/dossierBadges';
import { useDossiers } from '../../hooks/queries/useDossiers';
import { revealSlice, sortByRecentActivity } from '../../services/dashboard/ordreDuJour';
import { WidgetInfiniteList } from './WidgetInfiniteList';

export function RecentDossiersWidget() {
  const navigate = useNavigate();
  const { data: dossiers, isLoading } = useDossiers({
    include_archived: true,
    include_closed: true,
  });

  // Tous les dossiers visibles, du plus récemment modifié au plus ancien (demande du cabinet).
  const recents = useMemo(() => sortByRecentActivity(dossiers ?? []), [dossiers]);

  return (
    <Card
      className="h-full"
      headerClassName={WIDGET_HEADER_FLUSH}
      header={
        <WidgetCardHeader icon={FolderOpen} title="Dossiers récents" href="/dossiers" />
      }
    >
      {isLoading ? (
        <div className="flex justify-center py-4">
          <Spinner />
        </div>
      ) : recents.length === 0 ? (
        <p className="text-sm text-neutral-400 text-center py-3">
          Aucun dossier
        </p>
      ) : (
        <WidgetInfiniteList itemCount={recents.length}>
          {(visibleCount) => (
            <ul className="space-y-1">
              {revealSlice(recents, visibleCount).items.map((d) => (
                <li key={d.id}>
                  <button
                    type="button"
                    onClick={() => navigate(`/dossiers/${d.id}`)}
                    className="w-full flex items-center gap-2 text-left py-1 hover:bg-neutral-50 rounded px-1 transition-colors"
                  >
                    <div className="min-w-0 flex-1">
                      <span className="block text-sm text-neutral-700 truncate">{d.title}</span>
                      <span className="block text-[11px] text-neutral-400">{d.number}</span>
                    </div>
                    <div className="flex items-center gap-1 shrink-0">
                      <TypeBadge type={d.type_affaire} className="text-[10px]" />
                      <StageBadge stage={d.stage} className="text-[10px]" />
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </WidgetInfiniteList>
      )}
    </Card>
  );
}
